import EligibilityActionTypes from './types';

const initialState = {
  ruleSets: [],
  loading: false,
  saving: false,
  deleting: false,
  previewing: false,
  preview: null,
  error: null,
};

const eligibilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case EligibilityActionTypes.FETCH_RULE_SETS:
      return { ...state, loading: true, error: null };
    case EligibilityActionTypes.FETCH_RULE_SETS_SUCCESS:
      return { ...state, loading: false, ruleSets: action.payload || [] };
    case EligibilityActionTypes.FETCH_RULE_SETS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case EligibilityActionTypes.SAVE_RULE_SET:
      return { ...state, saving: true, error: null };
    case EligibilityActionTypes.SAVE_RULE_SET_SUCCESS:
      return { ...state, saving: false };
    case EligibilityActionTypes.SAVE_RULE_SET_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case EligibilityActionTypes.DELETE_RULE_SET:
      return { ...state, deleting: true, error: null };
    case EligibilityActionTypes.DELETE_RULE_SET_SUCCESS:
      return { ...state, deleting: false };
    case EligibilityActionTypes.DELETE_RULE_SET_FAILURE:
      return { ...state, deleting: false, error: action.payload };

    case EligibilityActionTypes.PREVIEW_ELIGIBILITY:
      return { ...state, previewing: true, error: null };
    case EligibilityActionTypes.PREVIEW_ELIGIBILITY_SUCCESS:
      return { ...state, previewing: false, preview: action.payload };
    case EligibilityActionTypes.PREVIEW_ELIGIBILITY_FAILURE:
      return { ...state, previewing: false, error: action.payload };
    case EligibilityActionTypes.CLEAR_PREVIEW:
      return { ...state, preview: null };

    default:
      return state;
  }
};

export default eligibilityReducer;
